const locales = [
  {
    'id': 1,
    'shortLocale': 'de',
    'locale': 'de_DE',
    'names': {
      'de': 'Deutsch',
      'en': 'German'
    }
  },
  {
    'id': 2,
    'shortLocale': 'en',
    'locale': 'en_GB',
    'names': {
      'de': 'Englisch',
      'en': 'English'
    }
  },
  {
    'id': 3,
    'shortLocale': 'fr',
    'locale': 'fr_FR',
    'names': {
      'de': 'Französisch',
      'en': 'French'
    }
  },
  {
    'id': 4,
    'shortLocale': 'es',
    'locale': 'es_ES',
    'names': {
      'de': 'Spanisch',
      'en': 'Spanish'
    }
  },
  {
    'id': 5,
    'shortLocale': 'it',
    'locale': 'it_IT',
    'names': {
      'de': 'Italienisch',
      'en': 'Italian'
    }
  },
  {
    'id': 6,
    'shortLocale': 'nl',
    'locale': 'nl_NL',
    'names': {
      'de': 'Niederländisch',
      'en': 'Dutch'
    }
  },
  {
    'id': 7,
    'shortLocale': 'da',
    'locale': 'da_DK',
    'names': {
      'de': 'Dänisch',
      'en': 'Danish'
    }
  },
  {
    'id': 8,
    'shortLocale': 'ru',
    'locale': 'ru_RU',
    'names': {
      'de': 'Russisch',
      'en': 'Russian'
    }
  },
  {
    'id': 9,
    'shortLocale': 'pt',
    'locale': 'pt_PT',
    'names': {
      'de': 'Portugiesisch (Portugal)',
      'en': 'Portuguese (Portugal)'
    }
  },
  {
    'id': 10,
    'shortLocale': 'sl',
    'locale': 'sl_SI',
    'names': {
      'de': 'Slowenisch',
      'en': 'Slovenian'
    }
  },
  {
    'id': 11,
    'shortLocale': 'pl',
    'locale': 'pl_PL',
    'names': {
      'de': 'Polnisch',
      'en': 'Polish'
    }
  },
  {
    'id': 12,
    'shortLocale': 'cs',
    'locale': 'cs_CZ',
    'names': {
      'de': 'Tschechisch',
      'en': 'Czech'
    }
  },
  {
    'id': 13,
    'shortLocale': 'bg',
    'locale': 'bg_BG',
    'names': {
      'de': 'Bulgarisch',
      'en': 'Bulgarian'
    }
  },
  {
    'id': 14,
    'shortLocale': 'ro',
    'locale': 'ro_RO',
    'names': {
      'de': 'Rumänisch',
      'en': 'Romanian'
    }
  },
  {
    'id': 15,
    'shortLocale': 'sr',
    'locale': 'sr_Latn_RS',
    'names': {
      'de': 'Serbisch',
      'en': 'Serbian'
    }
  },
  {
    'id': 16,
    'shortLocale': 'hu',
    'locale': 'hu_HU',
    'names': {
      'de': 'Ungarisch',
      'en': 'Hungarian'
    }
  },
  {
    'id': 17,
    'shortLocale': 'sk',
    'locale': 'sk_SK',
    'names': {
      'de': 'Sowakisch',
      'en': 'Slovak'
    }
  },
  {
    'id': 18,
    'shortLocale': 'hr',
    'locale': 'hr_HR',
    'names': {
      'de': 'Kroatisch',
      'en': 'Croatian'
    }
  },
  {
    'id': 19,
    'shortLocale': 'ar',
    'locale': 'ar_001',
    'names': {
      'de': 'Arabisch',
      'en': 'Arabic'
    }
  },
  {
    'id': 20,
    'shortLocale': 'ja',
    'locale': 'ja_JP',
    'names': {
      'de': 'Japanisch',
      'en': 'Japanese'
    }
  },
  {
    'id': 21,
    'shortLocale': 'tr',
    'locale': 'tr_TR',
    'names': {
      'de': 'Türkisch',
      'en': 'Turkish'
    }
  },
  {
    'id': 22,
    'shortLocale': 'zh',
    'locale': 'zh_CN',
    'names': {
      'de': 'Chinesisch (vereinfacht)',
      'en': 'Chinese (simplified)'
    }
  },
  {
    'id': 23,
    'shortLocale': 'sv',
    'locale': 'sv_SE',
    'names': {
      'de': 'Schwedisch',
      'en': 'Swedish'
    }
  },
  {
    'id': 24,
    'shortLocale': 'el',
    'locale': 'el_GR',
    'names': {
      'de': 'Griechisch',
      'en': 'Greek'
    }
  },
  {
    'id': 25,
    'shortLocale': 'no',
    'locale': 'no_NO',
    'names': {
      'de': 'Norwegisch',
      'en': 'Norwegian'
    }
  },
  {
    'id': 26,
    'shortLocale': 'fi',
    'locale': 'fi_FI',
    'names': {
      'de': 'Finnisch',
      'en': 'Finnish'
    }
  },
  {
    'id': 27,
    'shortLocale': 'lt',
    'locale': 'lt_LT',
    'names': {
      'de': 'Litauisch',
      'en': 'Lithuanian'
    }
  },
  {
    'id': 28,
    'shortLocale': 'lv',
    'locale': 'lv_LV',
    'names': {
      'de': 'Lettisch',
      'en': 'Latvian'
    }
  },
  {
    'id': 29,
    'shortLocale': 'pt_BR',
    'locale': 'pt_BR',
    'names': {
      'de': 'Portugiesisch (Brasilien)',
      'en': 'Portuguese (Brazil)'
    }
  },
  {
    'id': 30,
    'shortLocale': 'uk',
    'locale': 'uk_UA',
    'names': {
      'de': 'Ukrainisch',
      'en': 'Ukrainian'
    }
  },
  {
    'id': 31,
    'shortLocale': 'zh_Hant',
    'locale': 'zh_Hant',
    'names': {
      'de': 'Chinesisch (traditionell)',
      'en': 'Chinese (traditional)'
    }
  },
  {
    'id': 32,
    'shortLocale': 'en_US',
    'locale': 'en_US',
    'names': {
      'de': 'Englisch (US)',
      'en': 'English (US)'
    }
  },
  {
    'id': 33,
    'shortLocale': 'et',
    'locale': 'et_EE',
    'names': {
      'de': 'Estnisch',
      'en': 'Estonian'
    }
  },
  {
    'id': 34,
    'shortLocale': 'fa',
    'locale': 'fa_IR',
    'names': {
      'de': 'Persisch',
      'en': 'Persian'
    }
  }
]

export default locales
